import {useCallback, useEffect, useState} from "react";
import {getGeneralSettings, updateGeneralSettings} from "../../../services/settings";


export function useGeneralSettings() {
  const [settings, setSettings] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getGeneralSettings();
      setSettings(await getGeneralSettings());
    } catch (err) {
      setError({
        message: err.message,
        title: "Failed to fetch general settings"
      });
    } finally {
      setIsLoading(false);
    }
  }, []);


  // site_title, tag_line, site_address, email_address
  const save = async (data) => {
    try {
      setIsLoading(true);
      setSettings(await updateGeneralSettings(data));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {save, isLoading, settings, error};
}